(function (window, document, undefined) {
  "use strict";

  let Vue = window.Vue || false,
    logger;

  const renderWidget = (widget) => {
    if (!widget) {
      logger.log("_init: No widget.");
      return;
    }

    const topicTitle = widget.getAttribute("data-topic") || "";
    const topicSlug = widget.getAttribute("data-topic-slug") || "";
    const maxPosts = widget.getAttribute("data-max-posts") || 3;
    const maxPostAge = widget.getAttribute("data-max-age") || 0;
    const dynamicHeight = widget.getAttribute("data-dynamic-height") || true;

    Vue.createApp({
      components: {
        Widget: window["@russmedia-frontend/np-common"].MyTownTopicWidget,
      },
      setup() {
        const widgetProps = Vue.ref({
          dynamicHeight,
          maxPosts,
        });

        if (maxPostAge > 0) widgetProps.value.maxPostAge = maxPostAge;
        if (topicTitle && topicSlug) {
          widgetProps.topic = { title: topicTitle, slug: topicSlug };
        }

        return { widgetProps };
      },
      template: `<Widget v-bind="widgetProps" />`,
    }).mount("#vodl-topic-mytown");
  };

  const init = () => {
    try {
      logger = new window.RussMedia.Utils.Logger("[topic mytown] ");
    } catch (e) {
      logger = { log: function () {} };
    }

    if (!Vue) {
      logger.log("_init: No Vue!");
      return;
    } else {
      logger.log("Load Vue component.");
    }

    const widget = document.querySelector("#vodl-topic-mytown");

    if (widget) {
      renderWidget(widget);
    } else {
      logger.log("No widget found.");
    }
  };

  init();
})(window, document);
